import React, { FC, useCallback, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, restaurantConfig, doProductMobx } from 'restaurant'
import { showMsg, modalLayer } from '@utils'
import { format } from '@dt/fe-utils'
import { Stepper, BagIcon, ProductImage, Avatar, Tags } from 'components'
import { MultiCntModal } from '../../modal'
interface IProps {
  cartItem: IViewCombinedCartItem;
}

const MultiCartProductItem: FC<IProps> = ({ cartItem }) => {
  const isNeedEllipsis: boolean = !!((cartItem.optionStr).zhLength() > 16 || cartItem.offItems?.[0]?.offTip.zhLength() > 16 || cartItem.offItems.length > 1 || (cartItem.optionStr && cartItem.offItems.length))
  const [showDetail, setShowDetail] = useState([])

  const handleChangeCnt = useCallback((isAdd: boolean) => {
    if (isAdd) {
      const { productNo, scaleNo, cnt } = cartItem
      if (doProductMobx.checkInvalidByProductNo(productNo, scaleNo, cnt, cnt + 1)) {
        showMsg(i18n.t('productdetail.saleOutTips2'))
        return
      }
      cartMobx.add(cartItem.pks)
    } else {
      if (cartItem.pks.length > 1) {
        modalLayer(MultiCntModal, { pks: cartItem.pks })
          .then(() => { })
          .catch(() => { })
      } else {
        cartMobx.reduce(cartItem.pks)
      }
    }
  }, [cartItem.cnt])

  const optionModify = (cartItem: any, isNeedEllipsis: boolean) => {
    return (
      <div
        className='option-modify-offItems'
      >
        <div>
          <span>
            {
              showDetail.includes(cartItem?.pks ? cartItem?.pks.join('') : cartItem.pk) && !cartItem.optionStr
                ? '' : (
                  <span>
                    {
                      cartItem.optionStr || (isNeedEllipsis ? (
                        <>
                          <i className='iconfont icon-zhekou2x'></i>
                          <span>{cartItem.offItems?.[0]?.offTip}</span>
                        </>
                      ) : '')
                    }
                  </span>)
            }
            {isNeedEllipsis && !showDetail.includes(cartItem?.pks ? cartItem?.pks.join('') : cartItem.pk) ? (
              <i
                className='iconfont icon-zhankai2x'
                data-cypid={`multiCartItemOptionModifyShow_pk_${cartItem?.pk}`}
                onClick={(e) => {
                  e.stopPropagation()
                  setShowDetail([...showDetail, cartItem?.pks ? cartItem?.pks.join('') : cartItem.pk])
                }}
              >
              </i>) : null}
          </span>
          {
            cartItem.offItems.map((v, index: number) => {
              return (
                <p className='off-item' key={index}>
                  <i className='iconfont icon-zhekou2x'></i>
                  <span>{v.offTip}</span>
                </p>
              )
            })
          }
        </div>
        {
          isNeedEllipsis && showDetail.includes(cartItem?.pks ? cartItem?.pks.join('') : cartItem.pk) ? (
            <span
              className='item-detail-handle' data-cypid={`multiCartItemOptionModifyHide_pk_${cartItem?.pk}`} onClick={(e) => {
                e.stopPropagation()
                setShowDetail(showDetail.filter(v => v !== cartItem?.pks ? cartItem?.pks.join('') : cartItem.pk))
              }}
            >
              {i18n.t('newCart.hide')}
            </span>
          ) : null
        }
      </div>
    )
  }

  const productGroup = (cartItem: IViewCombinedCartItem) => {
    return (
      <div className='item-groups'>
        {
          cartItem.productGroups?.map(group => (
            <div key={group.no} className='item-group'>
              {
                group?.productGroupDetails.map(product => {
                  const needEllipsis: boolean = !!((product.optionStr).zhLength() > 16 || product.offItems?.[0]?.offTip.zhLength() > 16 || product.offItems.length > 1 || (product.optionStr && product.offItems.length))
                  return (
                    <div key={product.pk} className='item-group-product'>
                      <div className={`product-name${needEllipsis && !showDetail.includes(product.pk) ? ' need-ellipsis' : ''}`}>
                        <strong>{product.name}</strong>
                        {optionModify(product, needEllipsis)}
                        <div className='product-extra-info'>
                          <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
                        </div>
                      </div>
                      <div className='product-cnt'>x {product.cnt}</div>
                    </div>
                  )
                })
              }
            </div>
          ))
        }
      </div>
    )
  }

  return (
    <div className='cart-product-item' key={cartItem.pks.join('')}>
      <div className='product-info'>
        <div className='item-detail'>
          <ProductImage color={!cartItem.pic && restaurantConfig.displayMode === 'waterfall' ? cartItem.productNo : ''} width={40} imgSrc={cartItem.pic} />
          <div className={`product-name${isNeedEllipsis && !showDetail.includes(cartItem.pks.join('')) ? ' need-ellipsis' : ''}`}>
            <strong>{cartItem.name}</strong>
            {optionModify(cartItem, isNeedEllipsis)}
            <div className='product-extra-info'>
              <Tags datas={[...(cartItem.tags || []), ...(cartItem.allergys || [])]} disableSingleSale={!cartItem.isSingleSale} />
            </div>
          </div>
          <div className='product-price'>
            <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.actualPrice) }}></span>
            {cartItem.actualPrice !== cartItem.totalPrice && (!isNeedEllipsis || showDetail.includes(cartItem.pks.join(''))) ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.totalPrice) }}></del> : ''}
          </div>
        </div>
        {productGroup(cartItem)}
        <div className='item-actions'>
          <div className='user-list'>
            {cartItem.addUsers.map(user => (<Avatar key={user} userKey={user} />))}
          </div>
          <>
            {!!cartItem.isTogo && (
              <BagIcon size='small' />
            )}
            <Stepper uid={cartItem.pks.join('_')} cnt={cartItem.cnt} onChange={handleChangeCnt} />
          </>
        </div>
      </div>
    </div>
  )
}

export default observer(MultiCartProductItem)
